import { render, staticRenderFns } from "./JourneyStats.vue?vue&type=template&id=01225657&scoped=true&"
import script from "./JourneyStats.vue?vue&type=script&lang=js&"
export * from "./JourneyStats.vue?vue&type=script&lang=js&"
import style0 from "./JourneyStats.vue?vue&type=style&index=0&id=01225657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01225657",
  null
  
)

export default component.exports